const singleShopProductPage = () => import(/* webpackChunkName: 'single-product-pages' */ './src/views/single-shop-product-page.vue')
const singlePOSProductPage = () => import(/* webpackChunkName: 'single-product-pages' */ './src/views/single-pos-product-page.vue')
const singlePOSFoodProductPage = () => import(/* webpackChunkName: 'single-product-pages' */ './src/views/single-pos-food-product-page.vue')
const singlePOSModifierProductPage = () => import(/* webpackChunkName: 'single-product-pages' */ './src/views/single-pos-modifier-product-page.vue')
const singleWineGlassProductPage = () => import(/* webpackChunkName: 'single-product-pages' */ './src/views/single-wine-glass-product-page.vue')
const singleWineTastingProductPage = () => import(/* webpackChunkName: 'single-product-pages' */ './src/views/single-wine-tasting-product-page.vue')

export default {
  singleShopProductPage,
  singlePOSProductPage,
  singlePOSFoodProductPage,
  singlePOSModifierProductPage,
  singleWineTastingProductPage,
  singleWineGlassProductPage
}
